import React, { Fragment, useEffect, useState } from 'react';
import ThemeMenuOne from '../header/ThemeMenuOne';

const ThemeBannerOne = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 500); // Delay before fading in

        return () => clearTimeout(timer);
    }, []);

    return (
        <Fragment>
            {/* theme-banner-one start */}
            <div
                style={{
                    backgroundImage: 'url(assets/img/bg/banner-first.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    transition: 'opacity 1s ease-in-out',
                    opacity: isVisible ? 1 : 0,
                    position: 'relative',
                }}
                className="d-flex flex-column align-items-center justify-content-start"
            >
                {/* Overlay Mask */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(75, 74, 74, 0.5)', // semi-transparent black
                        zIndex: 1,
                    }}
                ></div>

                {/* Header Section */}
                <header className="w-100 text-center" style={{ zIndex: 2 }}>
                    <ThemeMenuOne />
                </header>

                {/* Banner Text */}
                <div
                    style={{
                        position: 'absolute',
                        top: '68%',
                        transform: 'translateY(-50%)',
                        textAlign: 'center',
                        zIndex: 2, // Above the mask
                    }}
                >
                    <h1 className="text-white bg-transparent responsive-text">
                        Empowering lives with simple,<br />
                        comprehensive solutions.
                    </h1>
                </div>
            </div>
            {/* theme-banner-one end */}
        </Fragment>
    );
};

export default ThemeBannerOne;
